import styles from './formControl.module.scss';

export default function FormControlContainer({ children }) {
  return (
    <div className={styles.formControl}>{children}</div>
  )
}
